module.exports = __webpack_public_path__ + "static/media/core.26300615.svg";